import React, { useEffect, useState } from 'react';
import { Input, Typography, Button, message, Spin, Form, } from 'antd';
import { get, put } from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import SunEditor from "suneditor-react";

const { Title } = Typography;

const EditNotification = () => {
    const navigate = useNavigate();
    let { Id } = useParams();
    const [fromloading, setFromLoading] = useState(false);
    const optionsSun = {
        buttonList: [
            ["undo", "redo"],
            ["font", "fontSize", "formatBlock"],
            ["paragraphStyle", "blockquote"],
            ["bold", "underline", "italic", "strike", "subscript", "superscript"],
            ["fontColor", "hiliteColor", "textStyle"],
            ["removeFormat"],
            //  '/', // Line break
            ["outdent", "indent"],
            ["align", "horizontalRule", "list", "lineHeight"],
            ["table", "link", "image", "video", "audio"],
            ["fullScreen", "showBlocks", "codeView"],
            ["preview", "print"],
            // ['save', 'template'],
        ],
        font: ["Arial",
            "Sans-Serif",
            'tahoma',
            'DroidArabicKufiRegular',
            "Georgia",
            "Tahoma",
            "Trebuchet MS",
            "Verdana",
            "Logical",
            "Salesforce Sans",
            "Garamond",
            "Serif",
            "Times New Roman",
            "Helvetica"],
    };

    const [inputsValue, setinputsValue] = useState({ title: "", content: "" });
    useEffect(() => {
        get(`notification-contents/${Id}`).then(res => {
            setinputsValue(res.data.data);
            setFromLoading(true);
        });
    }, []);
    const [loading, setLoading] = useState(false);
    const onFinish = (values) => {
        setLoading(true);
        console.log('values', values);
        put(`notification-contents/${Id}`, values).then(res => {
            message.success('تم تعديل بنجاح');
            setLoading(false);
            navigate('/notification-contents')
        }).catch(err => {
            message.error(err.response.data.message);
            setLoading(false);
        });
    };

    return (
        <div>
            <Title level={2} className='text-main mb-4'> تعديل الدور  </Title>
            {
                fromloading ?
                    <Form
                        onFinish={onFinish}
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 16,
                        }}

                        initialValues={{
                            "title": inputsValue.title,
                            "content": inputsValue.content
                        }}
                        autoComplete="off"
                    >
                        <div className='row'>
                            <div className='col-lg-12'>
                                <Form.Item
                                    label='محتوى الإشعار'
                                    name='title'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'هذا الحقل مطلوب!',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>
                            <div className='col-lg-12'>
                                <Form.Item
                                    label='محتوى الإشعار'
                                    name='content'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'هذا الحقل مطلوب!',
                                        },
                                    ]}
                                >
                                    {/*<TextArea />*/}
                                    <SunEditor
                                        defaultValue={inputsValue.content}
                                        showToolbar={false}
                                        setDefaultStyle="height: auto; min-height: 300px"
                                        setOptions={optionsSun}
                                    />
                                </Form.Item>
                            </div>

                            <div className='col-lg-4 offset-lg-4'>

                                <Form.Item
                                    wrapperCol={{
                                        offset: 1,
                                        span: 16,
                                    }}
                                >
                                    <Button
                                        loading={loading}
                                        size='large' block type="primary" htmlType="submit">
                                        {loading ? 'جاري التعديل...' : 'تعديل'}
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>



                    </Form>

                    :
                    <div className='text-center'>
                        <Spin size="large" />
                    </div>
            }
        </div>
    )
}

export default EditNotification
